module.exports = __webpack_public_path__ + "static/media/search.c8a4ef6f.svg";